import { useEffect, useState } from 'react'
import './App.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faBolt, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import { Helmet } from 'react-helmet'
import Markdown from 'react-markdown'

const tokenMapping = {
  '6ITcsTMC4JsCWYI4et5DcuATFZII4tTjqRm3qr4tv1dtvd1Y': ['paul', 'Paul AI', <>Paul AI is a conversational agent that gives advice intended for startup founders and is drawn from Paul Graham's tips and experiences with startups as shared on his book <a rel="noreferrer" href='https://www.youtube.com/@GarryTan' target='_blank'>"Hackers & Painters"</a>. You can learn more about Paul from <a rel="noreferrer" href='https://en.wikipedia.org/wiki/Paul_Graham_(programmer)' target='_blank'>here</a>.</>],
  'GK3sxVVjeDdPm6z7RXGs9XJBeRAMsSejcVshhTyJfbzgwpJS': ['michael', 'Michael AI', <>Michael AI is a conversational agent that gives advice intended for startup founders and is drawn from Michael Seibel's tips and experiences with startups as shared on multiple sources across the web. You can learn more about Michael from <a rel="noreferrer" href='https://en.wikipedia.org/wiki/Michael_Seibel' target='_blank'>here</a>.</>],
  '9pmYlED6eCq4KVBIu92JbKg0Zga208ADTD5BSjprgv4dxrK6': ['garry', 'Garry AI', <>Garry AI is a conversational agent that gives advice intended for startup founders and is drawn from Gary Tan's tips and experiences on startups as shared on his <a rel="noreferrer" href='https://www.youtube.com/@GarryTan' target='_blank'>YouTube channel</a>. You can learn more about Garry from <a rel="noreferrer" href='https://en.wikipedia.org/wiki/Garry_Tan' target='_blank'>here</a>.</>],
  'W5ByQwIZyp0li38PbfqsKsvjYhHmHqVOwig8t2ZgEwMSUdcW': ['johnk', 'John\'s Digital Presence', <>Welcome to the digital presence of John William Kachamila, geologist, educator, and former Minister of Mineral Resources and Energy of Mozambique. Through this interactive platform, engage in conversations with John's digital self, drawing from his rich life experiences spanning education, international travels, and decades of public service. Ask questions, seek advice, or simply chat about life - John is here to share his stories and wisdom with you.</>],
  'kV2jWRv1KK3u68DmyGtOFzU02dpIOsHYoa4Le9V7OMV4mekw': ['jamesc', 'James AI', <>James AI is a conversational agent that gives advice intended for startup founders and is drawn from James Currier's tips and experiences with startups as shared on multiple sources across the web. You can learn more about James from <a rel="noreferrer" href='https://www.svod.org/james-currier/' target='_blank'>here</a>.</>],
  'cpi1spcAm8X3lcsdYbLKGjkO1DoBHoK5jCQxbQfJ7lH0Yfrk': ['marketplace-book', 'MarketMind AI', <>MarketMind AI is a conversational agent that gives advice intended for startup founders and is drawn from the book 'A Guide to Marketplaces'. You can learn more about the book from <a rel="noreferrer" href='https://versionone.vc/marketplaces-guide-ed3/' target='_blank'>here</a>.</>],
  '3cuyvY4elox1lbA9JbpgYQTV1FJkdGrrS6zyxYDOfglRVAox': ['erikt', 'Erik AI', <>Erik AI is a conversational agent that gives advice intended for startup founders and is drawn from Erik Torenberg's posts on philosophy, technology and startups as shared on Substack. You can learn more about Erik from <a rel="noreferrer" href='https://substack.com/@eriktorenberg' target='_blank'>here</a>.</>],
  'Y5q6SV4LvRFBPPsTx1wvXCVMkCKXVX3eiGIdLzjtCey4IhgZ': ['hafiz', 'Hafez AI', <>Hafez AI invites you to delve into the enchanting world of The Divān of Hafez. Engage in captivating conversations, ask questions, and explore the beauty of Hafez's timeless poetry with our interactive companion. You can learn more about the book from <a rel="noreferrer" href='https://en.wikipedia.org/wiki/The_Div%C4%81n_of_Hafez' target='_blank'>here</a>.</>],
  'vUPXyThOsX0r5W7yXworyBEvH76XPEfa0egEE67mzVHGg9Gk': ['paul', 'Paul AI', <>Elevate your startup game with Paul AI. Derived from Paul Graham's expertise in <a rel="noreferrer" href='https://www.youtube.com/@GarryTan' target='_blank'>Hackers & Painters</a>, this conversational agent provides tailored advice for founders. Discover the keys to success and learn more about Paul <a rel="noreferrer" href='https://en.wikipedia.org/wiki/Paul_Graham_(programmer)' target='_blank'>here</a>.</>],
  'WRYAT5xRqvRQZBfoXqdOh4qHH6qYqJgw3L9gitp2SAjKHUz5': ['michael', 'Michael AI', <>Michael AI is a conversational agent that gives advice intended for startup founders and is drawn from Michael Seibel's tips and experiences with startups as shared on multiple sources across the web. You can learn more about Michael from <a rel="noreferrer" href='https://en.wikipedia.org/wiki/Michael_Seibel' target='_blank'>here</a>.</>],
  '5MXDxaXPL7kL2OpwyeM9aEY17ZjDwqArskaJv80uKT5ZOHkt': ['kanyi', 'Kanyi AI', <>Kanyi AI opens the door to insightful conversations based on Kanyi Maqubela's blog, <a rel="noreferrer" href='https://kanyi.blog/' target='_blank'>Musing</a>. Dive into discussions and ask questions related to his blog. Explore more about Kanyi's thoughts and ideas from <a rel="noreferrer" href='https://kanyi.me/' target='_blank'>here</a>.</>],
  'k3L9bzwoOacxaSKOXIlC8x8HE9GA5RDEzXCmEF4TPVABadTO': ['sahil', 'Sahil AI', <>Sahil AI is a conversational agent that gives advice intended for startup founders and is drawn from Sahil Lavingia's tips and experiences with startups as shared on his book <a rel="noreferrer" href='https://www.amazon.com/Minimalist-Entrepreneur-Great-Founders-More/dp/0593192397' target='_blank'>"The Minimalist Entrepreneur"</a>. You can learn more about Sahil from <a rel="noreferrer" href='https://sahillavingia.com/' target='_blank'>here</a>.</>]
}

const getProduct = () => {
  const urlParams = new URLSearchParams(window.location.search)
  var token = urlParams.get('token') || ''
  let _product = null
  
  if(token) {
    if(Object.keys(tokenMapping).includes(token)) {
      _product = tokenMapping[token]
      return _product
    }
  }
  return [null, null, null]
}

const [productID, productTitle, productDesc] = getProduct()

const App = () => {
  const [query, setQuery] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isInitializing, setIsInitializing] = useState('running')
  const [conversations, setConversations] = useState([])

  useEffect(() => {
    if(productID) {
      if(localStorage.hasOwnProperty(`conversations-${productID}`)) {
        setConversations(
          JSON.parse(localStorage.getItem(`conversations-${productID}`))
        )
      } else setConversations([])
      initialize()
    }
  }, [])

  const handleRequest = async (author, question) => {
    const convoSize = 50
    const includeConvoSize = 10
    if(isLoading) return
    if(author) {
      setIsLoading(true)
      let tempResult = [...conversations]
      const prompts = conversations.slice(-includeConvoSize)
      prompts.push({role: 'user', content: question})
      const baseUrl = getEndpoint()
      const endpoint = `${baseUrl}/answer`
      let response = null
      try {
        if(prompts?.length > 0) {
          response = await axios.post(endpoint, {prompts})
        } else {
          throw 'No query found!!'
        }
      } catch (err) {
        console.log(err)
      }
      let answer = response.data?.answer
      if(answer) {
        tempResult.push({role: 'user', content: question})
        tempResult.push({role: 'assistant', content: answer})

        /// keep conversation to a fixed size
        if (tempResult.length > convoSize) {
          tempResult = tempResult.slice(tempResult.length - convoSize)
        }

        setConversations(tempResult)
        localStorage.setItem(`conversations-${author}`, JSON.stringify(tempResult))
        setQuery('')
      }
      setIsLoading(false)
    }
  }

  const initialize = async () => {
    if(isInitializing === 'success') return
    let payload = { author: 'initialize', question: 'SELLAGEN_INITIALIZE_FUNCTION' }
    let response = null
    try {
      let baseUrl = getEndpoint()
      response = await axios.get(`${baseUrl}/init`)
      if(response.data?.response === 'DONE') {
        setIsInitializing('success')
      } else {
        setIsInitializing('failed')
      }
    } catch (err) {
      console.log(err)
      setIsInitializing('failed')
    }
  }

  if(productID === null) {
    return(
      <div className="App">
        <AppHelmet/>
        <div className='content-body'>
          <div className='intro'>
            <span><FontAwesomeIcon icon={faBolt}/>&nbsp;&nbsp;{productTitle}</span>
            <span style={{fontSize: '24px'}}><br/>You are not authorized!!</span>
          </div>
        </div>
      </div>
    )
  }

  if(isInitializing === 'failed') {
    return(
      <div className="App">
        <AppHelmet/>
        <div className='content-body'>
          <div className='intro'>
            <span><FontAwesomeIcon icon={faBolt}/>&nbsp;&nbsp;{productTitle}</span>
            <span style={{fontSize: '24px', fontWeight: 600}}>
              <br/>Initialization Failed! Please try again later.
            </span>
          </div>
        </div>
      </div>
    )
  }

  var intro = null
  var content = null
  var navBar = null
  if(conversations?.length > 0) {
    content = [...conversations]
    content.reverse()
    content = content.map((elem, i) => <ContentBlock key={i} role={elem.role} content={elem.content} agentName={'John'} special={productID==='hafiz'}/>)
    navBar = 
    <div className='nav-bar'>
      <FontAwesomeIcon icon={faBolt}/>&nbsp;&nbsp;{productTitle}&nbsp;&nbsp;{isInitializing === 'running' ? <Loader/> : null}
    </div>
  } else {
    if(isInitializing === 'running') {
      intro = 
      <>
        <div className='intro'>
          <span style={{fontSize: '24px', fontWeight: 600}}>
            <FontAwesomeIcon icon={faBolt}/>&nbsp;&nbsp;{productTitle} Initializing&nbsp;&nbsp;<Loader/>
          </span>
        </div>
        <div className='info'>{productDesc}</div>
      </>
    } else {
      let additional = null
      if(productID === 'johnk' || productID === 'hafiz' || productID === 'kanyi') {
        additional = 'Do you have any questions in mind?'
      } else if(productID === 'marketplace-book') {
        additional = 'Do you have any marketplace question in mind?'
      } else {
        additional = 'Do you have any startup question in mind?'
      }
      intro = 
      <>
        <div className='intro'>
          {/* <p style={{fontStyle: 'italic', fontSize: '26px', whiteSpace: 'pre-line'}}>{productTitle}</p> */}
          <span><FontAwesomeIcon icon={faBolt}/>&nbsp;&nbsp;{productTitle}</span>
          <br/>
          <span style={{fontSize: '18px', fontWeight: 400, fontStyle: 'italic'}}><br/>What's on your mind?</span>
        </div>
        <div className='info'>{productDesc}</div>
      </>
    }
  }
  return (
    <div className="App">
      <AppHelmet/>
      {navBar}
      <div className='content-body' style={{display: 'flex', flexDirection: 'column-reverse'}}>
        {content}
        {conversations.length > 0 ? <div style={{flex: 1}}></div> : null}
        {intro}
      </div>
      <form className='search-form' action='#'>
        {isLoading ? <div className='search-icon'><Loader/></div> : null}
        <input className='search-input' type='text'
          placeholder={isInitializing === 'running' ? 'Initializing...' : 'Ask away...'}
          autoFocus
          // disabled={isInitializing === 'running' || isLoading ? true : false}
          value={query}
          onChange={(e) => {
              if(!(isInitializing === 'running' || isLoading)) {
                setQuery(e.target.value)
              }
            }
          }
          onKeyDown={e => {
            if(!(isInitializing === 'running' || isLoading)) {
              if(e.key === 'Enter' && !e.shiftKey) {
                handleRequest(productID, query)
                e.preventDefault()
              }
            }
          }}
        />
        <div style={{width: '100%', fontSize: '11px', padding: '7.5px', color: 'rgb(150, 150, 150)'}}>
          {productTitle} is powered by <a rel="noreferrer" href='https://sellagen.com' target='_blank' style={{color: '#fa7b26'}}>Sellagen Inc.</a> As an AI, it can make mistakes. Consider checking important information.
        </div>
      </form>
      {
        conversations?.length > 0 ?
        <div className='setting' onClick={() => {
          localStorage.setItem(`conversations-${productID}`, JSON.stringify([]))
          setConversations([])
        }}>
          <FontAwesomeIcon icon={faTrashAlt}/>
          <div className='expand'><div className='setting-options'>Clear Chat</div></div>
        </div>
        : null
      }
    </div>
  )
}

export default App

const AppHelmet = () => (<Helmet><title>{productTitle}</title></Helmet>)

const getEndpoint = () => {
  if(window.location.hostname === 'localhost') {
    return 'http://localhost:4000/api/misc'
  } else return 'https://sellagen.com/api/misc'
}

const ContentBlock = ({role, content, agentName, special=false}) => {
  var roleName = ''
  var roleIcon = null
  if(role === 'assistant') {
    roleName = agentName
    roleIcon = faBolt
  } else {
    roleName = 'You'
    roleIcon = faUser
  }

  const splitStringWithQuotation = (inputString) => {
    const regex = /"([^"]*)"/g
    const resultArray = []
    let lastIndex = 0
    let match
    while ((match = regex.exec(inputString)) !== null) {
      resultArray.push(inputString.substring(lastIndex, match.index))
      resultArray.push(match[0])
      lastIndex = regex.lastIndex
    }
    resultArray.push(inputString.substring(lastIndex));
    return resultArray
  }

  // if(special && role === 'assistant') {
  //   const result = splitStringWithQuotation(content)
  //   content = result.map(element => {
  //     if(element.startsWith('"') && element.endsWith('"')) {
  //       return <span className='special-quote'>{element}</span>
  //     } else {
  //       return element
  //     }
  //   })
  // }
  if(role === 'assistant') {
    content = (
      <div className='markdown-wrapper'>
        <Markdown>{content}</Markdown>
      </div>
    )
  }

  return (
    <div className='convo-block'>
      <div style={{height: '40px', width: '200px', display: 'flex', alignItems: 'center', fontWeight: 600
    }}>
        <div style={{height: '25px', width: '25px', borderRadius: '50%', backgroundColor: 'rgb(45, 46, 48)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgb(32, 33, 36)',
          fontSize: '16px', marginRight: '10px'
        }}>
          <FontAwesomeIcon icon={roleIcon}/>
        </div>
        <span style={{paddingBottom: '1px', borderBottom: '1.5px solid #FF6700'}}>{roleName}</span><br/>
      </div>
      <div className={`text-container${role === 'assistant' ? '-assistant' : ''}`}>
        {content}
      </div>
    </div>
  )
}

const Loader = () => {
  return (
    <div className='loader'>
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        width="24px" height="30px" viewBox="0 0 24 30">
        <rect x="0" y="0" width="4" height="10" fill="#333">
          <animateTransform attributeType="xml"
            attributeName="transform" type="translate"
            values="0 0; 0 20; 0 0"
            begin="0" dur="0.6s" repeatCount="indefinite" />
        </rect>
        <rect x="10" y="0" width="4" height="10" fill="#333">
          <animateTransform attributeType="xml"
            attributeName="transform" type="translate"
            values="0 0; 0 20; 0 0"
            begin="0.2s" dur="0.6s" repeatCount="indefinite" />
        </rect>
        <rect x="20" y="0" width="4" height="10" fill="#333">
          <animateTransform attributeType="xml"
            attributeName="transform" type="translate"
            values="0 0; 0 20; 0 0"
            begin="0.4s" dur="0.6s" repeatCount="indefinite" />
        </rect>
      </svg>
    </div>
  )
}